export default __webpack_public_path__ + "static/media/haraka-logo.3b9b4f1c.png";